<ng-container *transloco="let t;">
<app-detail-view [loading]="loading" [messages]="messages" [close]="false">

    <div title>
      <h1>
        {{ t('my_profile.my_profile') }}
      </h1>
    </div>

    <div details>

      <app-profile-basedata [user]="user" (setEdit)="setEdit($event)" *ngIf="!user?.showAdditionalData()"></app-profile-basedata>

      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex" *ngIf="user?.showAdditionalData()">

        <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
          <app-profile-basedata [user]="user" (setEdit)="setEdit($event)"></app-profile-basedata>
        </p-tabPanel>

        <p-tabPanel *ngIf="sysMode === 'planner'" header="{{ t('common.labels.languages_locations') }}" leftIcon="pi pi-map-marker" [disabled]="isDisabled('locations') || user === null">
          <app-user-locations [user]="user" [viewMode]="'profile'" (setEdit)="setEdit($event)"></app-user-locations>
        </p-tabPanel>

        <p-tabPanel *ngIf="sysMode === 'planner'" header="{{ t('common.labels.procedures') }}" leftIcon="pi pi-clone" [disabled]="isDisabled('templates') || user === null">
          <app-user-templates [user]="user" [viewMode]="'profile'" (setEdit)="setEdit($event)"></app-user-templates>
        </p-tabPanel>

      </p-tabView>

    </div>

  </app-detail-view>
</ng-container>
